import { Subject } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';

const LISTENER_NAMES: Array<'online' | 'offline'> = ['online', 'offline'];
function mapListenerNames(isOnline: boolean): { prev: 'online' | 'offline'; curr: 'online' | 'offline' } {
  const map: Array<'online' | 'offline'> = isOnline ? LISTENER_NAMES : LISTENER_NAMES.slice().reverse();
  return { prev: map[0], curr: map[1] };
}

@Injectable({ providedIn: 'root' })
export class SgConnectionStateService implements OnDestroy {
  get state(): boolean {
    return navigator.onLine;
  }
  stateChange = new Subject<boolean>();

  private _lastState: boolean;
  private _currentListener: (e) => void;

  constructor() {
    this._lastState = this.state;
    this.handleChagne();
  }

  private handleChagne(): void {
    const listnerMap = mapListenerNames(this.state);

    if (this._currentListener) {
      window.removeEventListener(listnerMap.prev, this._currentListener);
    }

    this._currentListener = (e) => {
      if (this._lastState !== this.state) {
        this._lastState = this.state;
        this.stateChange.next(this.state);
        this.handleChagne();
      }
    };

    window.addEventListener(listnerMap.curr, this._currentListener);
  }

  ngOnDestroy(): void {
    this.stateChange.complete();
    if (this._currentListener) {
      const listnerMap = mapListenerNames(this.state);
      window.removeEventListener(listnerMap.prev, this._currentListener);
    }
  }
}
